// import React, { useEffect, useRef, useState } from 'react';
// import styles from './scss/orchestrate.module.scss';
// import { assets } from '../../styles/assets/assets';
// import { getLycaSegementationTargetExperience } from '../../apiservice/aiLycaPilot';

// const TypingText = ({
//   text,
//   onDone,
//   speed = 50,
// }: {
//   text: string | number;
//   onDone?: () => void;
//   speed?: number;
// }) => {
//   const [displayedText, setDisplayedText] = useState('');

//   useEffect(() => {
//     let i = 0;
//     const safeText = String(text); // ✅ ensure it's always a string
//     setDisplayedText('');
//     const interval = setInterval(() => {
//       setDisplayedText(safeText.slice(0, i + 1));
//       i++;
//       if (i === safeText.length) {
//         clearInterval(interval);
//         if (onDone) onDone();
//       }
//     }, speed);

//     return () => clearInterval(interval);
//   }, [text, speed, onDone]);

//   return <>{displayedText}</>;
// };
// const Orchestrate4 = ({ onComplete }: { onComplete?: () => void }) =>{
//  const [data, setData] = useState<any[]>([]);
//   const [visibleSection, setVisibleSection] = useState(0);
//   const [phase, setPhase] = useState<'title' | 'desc' | 'chart' | 'done'>('title');
//   const chartRefs = useRef<(HTMLDivElement | null)[]>([]);
// console.log('data--',data[0])
//   // Fetch API Data
//   const getLycaSegementationTargetData = async (body: any) => {
//     try {
//       const res = await getLycaSegementationTargetExperience(body);
//       if (res?.data?.statusCode === 200) {
//         const responseData = res.data.response;
//         setData(responseData);
//       }
//     } catch (error) {
//       console.error('Error fetching segmentation target data:', error);
//     }
//   };

//   useEffect(() => {
//     const body = { fromYear: '2024', toYear: '2025', domainId: ' ' };
//     getLycaSegementationTargetData(body);
//   }, []);

//   // Example static sections (later you can map from `data`)
//   const sections = [
//     {
//       title: 'Email',
//       desc: 'Active Customers',
//       chart: 'Active customers interacting across multiple touchpoints.',
//       color: 'linear-gradient(180deg, #FFF 50%, #F5FFFC 100%)',
//     },
//     {
//       title: data[0]?.Segment ?? 0,
//       desc: 'Segments',
//       chart: 'Customer groups based on shared traits, behavior, or value.',
//       color: 'linear-gradient(180deg, #FFF 50%, #F5F5FF 100%)',
//     },
//     {
//       title: data[0]?.inactiveCustomers ?? 0,
//       desc: 'Inactive Customers',
//       chart: 'Previously active customers who’ve stopped interacting or transacting recently.',
//       color: 'linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)',
//     },
//     {
//       title: data[0]?.Complaints ?? 0,
//       desc: 'Complaints',
//       chart: 'Reported customer issues that may impact satisfaction and retention.',
//       color: 'linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)',
//     },
//   ];

//   // Auto scroll when section changes
//   useEffect(() => {
//     chartRefs.current[visibleSection]?.scrollIntoView({
//       behavior: 'smooth',
//       block: 'center',
//     });
//   }, [visibleSection]);

//   // Reset phase on new section
//   useEffect(() => {
//     setPhase('title');
//   }, [visibleSection]);

//   // Typing flow control
//   const onTypingDone = () => {
//     if (phase === 'title') {
//       setPhase('desc');
//     } else if (phase === 'desc') {
//       setPhase('chart');
//     } else if (phase === 'chart') {
//       setPhase('done');
//       setTimeout(() => {
//         if (visibleSection < sections.length - 1) {
//           setVisibleSection((prev) => prev + 1);
//         } else {
//           onComplete?.(); // ✅ Trigger after last section
//         }
//       }, 300);
//     }
//   };

//    return(
//     <>
//        <div className={styles.allotmentsecsegt}>
//       {sections.map((section, i) => {
//         if (i > visibleSection) return null;

//         const isCurrent = i === visibleSection;

//         return (
//           <div
//             key={i}
//             className={styles.altblocksegt}
//             ref={(el) => (chartRefs.current[i] = el)}
//           >
//             <p className={styles.altcount}>
//               {isCurrent ? (
//                 phase === 'title' ? (
//                   <TypingText text={section.title} onDone={onTypingDone} />
//                 ) : (
//                   section.title
//                 )
//               ) : (
//                 section.title
//               )}
//             </p>

//             <div className={styles.altinfos}>
//               <p>
//                 {isCurrent ? (
//                   phase === 'desc' ? (
//                     <TypingText text={section.desc} onDone={onTypingDone} />
//                   ) : phase === 'title' ? (
//                     ''
//                   ) : (
//                     section.desc
//                   )
//                 ) : (
//                   section.desc
//                 )}
//               </p>
//               <span>
//                 {isCurrent ? (
//                   phase === 'chart' ? (
//                     <TypingText text={section.chart} onDone={onTypingDone} />
//                   ) : phase === 'done' ? (
//                     section.chart
//                   ) : (
//                     ''
//                   )
//                 ) : (
//                   section.chart
//                 )}
//               </span>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//     </>
//    )
// }
// export default Orchestrate4;

import React, { useEffect, useRef, useState } from 'react';
import styles from './scss/orchestrate.module.scss';
import { assets } from '../../styles/assets/assets';
import { dashboardAction } from '../../store/slices/dashboard';
import { useDispatcher } from '../../custom_hooks/use_app_dispatch';

const TypingText = ({
  text,
  onDone,
  speed = 50,
}: {
  text: string | number;
  onDone?: () => void;
  speed?: number;
}) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    let i = 0;
    const safeText = String(text);
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(safeText.slice(0, i + 1));
      i++;
      if (i === safeText.length) {
        clearInterval(interval);
        if (onDone) onDone();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onDone]);

  return <>{displayedText}</>;
};

const Orchestrate4 = ({ onComplete }: { onComplete?: () => void }) => {
  const [visibleSection, setVisibleSection] = useState(0);
  const [phase, setPhase] = useState<'header' | 'view' | 'para' | 'timer' | 'done'>('header');
  const chartRefs = useRef<(HTMLDivElement | null)[]>([]);
  const dispatch = useDispatcher()

  // ✅ Static data replacing API response
  const sections = [
    {
      taskheader: 'Email',
      taskview: { icon: assets.email_icon, label: 'Email' },
      taskpara: '"Thanks for your purchase! You might also like these matching products."',
      timer: 'Tomorrow, 9:00 AM',
    }
  ];

  // Auto-scroll to current block
  useEffect(() => {
    chartRefs.current[visibleSection]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [visibleSection]);

  // Reset phase when new section starts
  useEffect(() => {
    setPhase('header');
  }, [visibleSection]);

  const onTypingDone = () => {
    if (phase === 'header') setPhase('view');
    else if (phase === 'view') setPhase('para');
    else if (phase === 'para') setPhase('timer');
    else if (phase === 'timer') {
      setPhase('done');
      setTimeout(() => {
        if (visibleSection < sections.length - 1) {
          setVisibleSection((prev) => prev + 1);
        } else {
          onComplete?.();
          dispatch(dashboardAction.setAnimation(true))
        }
      }, 300);
    }
  };

  return (
    <>
      <div className={styles.topheading}>
        <h4>Task Journey</h4>
        <p className={styles.headerdesctxt}>Track task journey</p>
      </div>
      {sections.map((section, i) => {
        if (i > visibleSection) return null;

        const isCurrent = i === visibleSection;

        return (
          <>




            <div className={styles.taskblockmain} ref={(el) => (chartRefs.current[i] = el)}>
              <div className={styles.taskblock}>
                <div className={styles.taskheader}>
                  {isCurrent && phase === 'header' ? (
                    <TypingText text={section.taskheader} onDone={onTypingDone} />
                  ) : (
                    section.taskheader
                  )}
                </div>
                <div className={styles.taskview}>
                  {isCurrent && phase === 'view' ? (
                    <>
                      <img src={section.taskview.icon} alt={section.taskview.label} />
                      <TypingText text={section.taskview.label} onDone={onTypingDone} />
                    </>
                  ) : (
                    <>
                      <img src={section.taskview.icon} alt={section.taskview.label} />
                      {section.taskview.label}
                    </>
                  )}
                </div>
                <div className={styles.taskpara}>
                  {isCurrent && phase === 'para' ? (
                    <TypingText text={section.taskpara} onDone={onTypingDone} />
                  ) : (
                    section.taskpara
                  )}
                </div>
                <div className={styles.timer}>
                  {isCurrent && phase === 'timer' ? (
                    <TypingText text={section.timer} onDone={onTypingDone} />
                  ) : (
                    section.timer
                  )}
                </div>
              </div>
            </div>
          </>
        );
      })}

    </>
  );
};

export default Orchestrate4;
